import React from 'react';
import { List, Datagrid, TextField, EditButton, ChipField } from 'react-admin';
import { LANGUAGES } from '../services/constants';

export const TrainingTypeList = (props) => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid rowClick="edit">
      <TextField source={LANGUAGES.EN} />
      <TextField source={LANGUAGES.HE} />
      <ChipField label="Speciality" source="speciality.name" />
      <EditButton />
    </Datagrid>
  </List>
);
